﻿import "./checkboxIcon.filter";
import "./duration.filter";
import "./highlight.filter";
import "./localFromUtc.filter";
import "./lowercaseFirst.filter";
import "./percentage.filter";
import "./radioIcon.filter";
import "./removeSpaces.filter";
import "./sbHtmlToPlainText.filter";
import "./sbHtmlToPlainText2.filter";
import "./sbPercentage.filter";
import "./sbReplaceSingleQuote.filter";
import "./sbReplaceSpaceWithDash.filter";
import "./sbSubstring.filter";
import "./slugify.filter";
import "./sumByField.filter";
import "./trustAsHtml.filter";
import "./trustAsResourceUrl.filter";
import "./version.filter";
import "./yesNo.filter";